import { Component } from '@angular/core';

import { BaseComponentClassDirective } from '~shared/classes/base-component.class';
import { ACCOUNT_INFORMATION_LINK, ACCOUNT_CHANGE_EMAIL_LINK } from '~shared/constants/links.constants';

@Component({
  selector: 'app-after-change-email',
  templateUrl: './after-change-email.component.html',
})
export class AfterChangeEmailComponent extends BaseComponentClassDirective {
  public templateOptions = {
    accountInfoLink: ACCOUNT_INFORMATION_LINK,
    changeEmailLink: ACCOUNT_CHANGE_EMAIL_LINK,
  };
}
